import React from 'react';

const About = () => {
    return (
        <section className="about">
            <div className="container">
                <div className="about__title-box">
                    <h2 className="about__title">Po zdrowie</h2>
                    <div className="about__title-hr"></div>
                </div>
                <p className="about__paragraph">
                    PO ZDROWIE to działalność fizjoterapeutyczna założona w&nbsp;2018 roku, która&nbsp;powstała z&nbsp;pasji
                    i&nbsp;wieloletniego doświadczenia.
                </p>
                <p className="about__paragraph">
                    Wśród oferowanych przeze mnie zabiegów znajdą Państwo
                    rehabilitację pourazową oraz ogólnoustrojową, korekcję wad postawy, różne warianty
                    masażu, trening medyczny, suche igłowanie a&nbsp;także kinesjotaping. W&nbsp;ramach swojej
                    działalności pomagam młodzieży i&nbsp;osobom dorosłym. 
                </p>
                <p className="about__paragraph">
                    W&nbsp;zakładce "Usługi" znajdą Państwo
                    opisy oferowanych przeze mnie zabiegów.<br/>
                    Serdecznie zapraszam do zapoznania się
                    z&nbsp;ofertą oraz do kontaktu.
                </p>
            </div>
        </section>
    );
}

export default About;